import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { ShellState } from '../../../states';
import { NavigationTarget } from '../../navigation-target';
import { LegacyRoutes, ShellRoutes } from '../../portal-routes';
import { PortalUrls } from '../../portal-urls.service';
import { LandingRule } from '../landing-rule';

/**
 * Fallback: buyers land in the Order Pro basket. A user the Order Pro basket is not open to lands on the
 * Legacy dashboard instead (as the Legacy basket guard did): the Shell would only show "unauthorized", whose
 * "homepage" link leads back to the landing route and thus to the same page again.
 * The permission check is the one of `UserPermissionGuard`, which protects the basket route.
 */
@Injectable({ providedIn: 'root' })
export class OrderProBasketLandingRule implements LandingRule {
  private readonly store = inject(Store);
  private readonly urls = inject(PortalUrls);

  resolve(): NavigationTarget {
    return this.store.selectSnapshot(ShellState.hasPathPermission(ShellRoutes.orderProBasket))
      ? NavigationTarget.internal(ShellRoutes.orderProBasket)
      : NavigationTarget.external(this.urls.legacyPortal(LegacyRoutes.dashboard));
  }
}
